import React from 'react';

const Copyright = () => {
    return <div>HeartyConsulting CRM ©{new Date().getFullYear()} Created by FengJie</div>;
};

export default Copyright;
